import React from "react";
import HomePage from "../pages/HomePage";
import CustomerMenu from "../pages/CustomerMenu";

/**
 * Root route: show default store menu (main landing or subdomain). Fallback: HomePage (onboarding).
 */
const SmartHome = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");

  const isMainLanding =
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "www.localhost" ||
    parts.length === 2 ||
    (parts.length >= 2 && parts[0] === "www");
  const hasSubdomain =
    parts.length >= 2 &&
    parts[0] !== "www" &&
    (parts[parts.length - 1] === "localhost" || parts.length > 2);

  if (isMainLanding || hasSubdomain) return <CustomerMenu />;
  return <HomePage />;
};

export default SmartHome;
